import { Link } from "react-router-dom";
import { ArrowRight, Gem, Flame, Sofa, Ruler, AlignHorizontalJustifyCenter, Bell, Music, Droplet, Wind, ThermometerSun, BedDouble } from "lucide-react";
import { COMFORT_TOOLS } from "@/data/comfortTools";

const ICON_MAP = {
    Gem, Flame, Sofa, Ruler, AlignHorizontalJustifyCenter,
    Bell, Music, Droplet, Wind, ThermometerSun, BedDouble,
};

// Section condensée pour la page d'accueil — vignettes photo cliquables.
export default function ComfortToolsSection() {
    return (
        <section
            id="confort-outils"
            data-testid="comfort-tools-section"
            className="py-20 md:py-28 bg-[#FAF7F2] scroll-mt-24"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <div className="max-w-2xl mb-10">
                    <div className="text-xs tracking-[0.3em] uppercase text-[#E07A5F] mb-4">
                        Confort & outils utilisés
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl font-light text-[#2C2A29] tracking-tight leading-tight">
                        Le matériel qui{" "}
                        <span className="italic text-[#E07A5F]">travaille avec moi</span>.
                    </h2>
                    <p className="mt-4 text-[#6E6862] leading-relaxed text-base md:text-lg">
                        Table Master, guashas de jade, pad chauffant, bâton thaï, traversins, bol tibétain, tongue drum et — à domicile seulement — huiles essentielles, encens et rituel Aufguss. Chaque outil a une raison d&apos;être précise.
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                    {COMFORT_TOOLS.map((tool) => {
                        const Icon = ICON_MAP[tool.icon];
                        const isDomicile = !tool.context.startsWith("Clinique");
                        return (
                            <Link
                                key={tool.id}
                                to="/confort-et-outils"
                                data-testid={`comfort-tool-mini-${tool.id}`}
                                className="group rounded-2xl bg-white border border-[#E8E2D9] overflow-hidden hover:border-[#E07A5F] hover:-translate-y-0.5 transition-all duration-300"
                            >
                                {tool.image && (
                                    <div className="aspect-square w-full overflow-hidden bg-[#FAF7F2]">
                                        <img
                                            src={tool.image}
                                            alt={tool.name}
                                            loading="lazy"
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                        />
                                    </div>
                                )}
                                <div className="p-3">
                                    <div className="flex items-center gap-1.5 mb-1">
                                        {Icon && <Icon size={14} className={isDomicile ? "text-[#E07A5F]" : "text-[#3D8C95]"} />}
                                        <div className="font-display text-sm text-[#2C2A29] leading-tight truncate">
                                            {tool.name}
                                        </div>
                                    </div>
                                    <div className={`text-[10px] uppercase tracking-widest ${isDomicile ? "text-[#E07A5F]" : "text-[#6E6862]"}`}>
                                        {tool.context}
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>

                <div className="mt-8 text-center">
                    <Link
                        to="/confort-et-outils"
                        data-testid="comfort-tools-full-link"
                        className="inline-flex items-center gap-2 text-sm text-[#3D8C95] hover:text-[#2C6D75] underline underline-offset-4"
                    >
                        Voir chaque outil en détail (+ animation Aufguss) <ArrowRight size={14} />
                    </Link>
                </div>
            </div>
        </section>
    );
}
